export const classes = {
  chip: 'inline-flex justify-center items-center gap-1 rounded-lg bg-slate-500/10 border border-slate-500/20 text-slate-700 text-xs text-center font-medium py-0.5 px-2 whitespace-nowrap dark:bg-slate-400/[0.16] dark:border-slate-400/25 dark:text-slate-100',
};
